<template>
  <header class="header_area">
    <FreeShippingTopBanner/>
    <div class="main_menu">
      <div class="container">
        <b-navbar toggleable="xl" class="w-100" type="light">
          <b-navbar-brand href="/" class="logo_h" style="height:auto">
            <img src="../assets/img/logo.png" width="137" class="img-fluid" alt="SanitizerWristbands" />
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-nav-item class="custom-nav-item" v-on:click="trackHeaderClick" href="/shop">SHOP</b-nav-item>
            <b-nav-item class="custom-nav-item" v-on:click="trackHeaderClick" href="/resell">RESELL</b-nav-item>
            <b-nav-item class="custom-nav-item" v-on:click="trackHeaderClick" href="/contact">CONTACT</b-nav-item>
            <b-nav-item class="custom-nav-item" v-on:click="trackHeaderClick" href="https://medium.com/sanitizerwristbands">BLOG</b-nav-item>
             <b-nav-item class="custom-nav-item" v-on:click="trackHeaderClick" href="/faq">F.A.Q</b-nav-item>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-nav-item href="#">
                <Cart />
              </b-nav-item>
              <b-nav-item href="#">
                <Account />
              </b-nav-item>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </div>
  </header>
</template>
<script>
import Account from '@/components/Account'
import Cart from '@/components/CartButton'
import FreeShippingTopBanner from '@/components/FreeShippingTopBanner'

export default {
  components: {
    Account,
    Cart,
    FreeShippingTopBanner
  },
  methods: {
    trackHeaderClick (e) {
      window.analytics.track('Clicked from Header', {
        destination: e.target.innerText
      })
    }
  }
}
</script>
<style scoped>
.responsive {
  width: 100%;
  height: auto;
}
.custom-nav-item {
  margin-right: 45px;
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue